var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "transition",
        {
          attrs: {
            name: "fade",
            "enter-active-class": "fadeIn",
            "leave-active-class": "fadeOut",
          },
        },
        [
          _vm.showModal
            ? [_c("div", { staticClass: "page-modal-background" })]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: {
            name: "slide",
            "enter-active-class": "slideInRight",
            "leave-active-class": "slideOutRight",
          },
        },
        [
          _vm.showModal
            ? [
                _c(
                  "div",
                  {
                    staticClass: "page-modal-wrapper",
                    on: {
                      click: function ($event) {
                        if ($event.target !== $event.currentTarget) {
                          return null
                        }
                        return _vm.onWrapperClick.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "page-modal-container" }, [
                      _c(
                        "div",
                        { staticClass: "page-modal-inner" },
                        [_vm._t("default")],
                        2
                      ),
                    ]),
                  ]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }